import script from "./BrandPortfolioMixin.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__